import { Collapse, List } from "@mui/material";
import { Fragment, useEffect, useMemo } from "react";
import useTrees from "../../../../../../Hooks/useTrees";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import Divider from "../../../../../UI/GeneralPurpose/Divider";
import MoreLess from "../Botones/MoreLess";
import Category from "./Category";

export const moreCategoriesUI = "moreCategories";
export const currentCatsUI = "currentCategories";
export const shouldExpandUI = "shouldExpand";

const MailCategories = () => {
  const { dispatch, UI } = useUIBp();
  const current = UI[currentCatsUI] ?? [];
  const catsCount = current.length;
  const expanded = UI[moreCategoriesUI];
  const trees = useTrees();
  const categories = useMemo(() => {
    let cats = [];
    for (const key in trees) {
      if (key.match("mails-")) {
        cats.push(trees[key]);
      }
    }
    // The endpoint order is not stable, so sort top-level folders by name to
    // keep the sidebar consistent between requests.
    cats.sort((a, b) => {
      const A = (a[0]?.displayName ?? "").toLowerCase();
      const B = (b[0]?.displayName ?? "").toLowerCase();
      return A < B ? -1 : A > B ? 1 : 0;
    });
    return cats;
  }, [trees]);

  useEffect(() => {
    if (catsCount > 6) {
      dispatch(UIactions.setValue({ id: shouldExpandUI, value: true }));
    } else {
      dispatch(UIactions.setValue({ id: shouldExpandUI, value: false }));
      dispatch(UIactions.setValue({ id: moreCategoriesUI, value: false }));
    }
  }, [dispatch, catsCount]);

  const categoriesButtons = categories.map((tree, idx) => <Category key={idx} {...{ tree, idx: 0, level: 0, root: tree[0].id }} />);

  return (
    <Fragment>
      <Divider {...{ color: "secondary.light" }} />
      <List
        dense
        sx={{
          width: 250,
          flex: 1,
          minHeight: 0,
          overflowY: "scroll",
        }}
        disablePadding
      >
        <Collapse in={expanded} collapsedSize="38vh">
          {categoriesButtons}
        </Collapse>
        <MoreLess />
      </List>
    </Fragment>
  );
};

export default MailCategories;
